export function numberFormatter(param, fractionalDigits = 2){
    if(param && param.value) {
        let number = Intl.NumberFormat("en", {
            maximumFractionDigits: fractionalDigits,
            minimumFractionDigits: fractionalDigits,
        }).format(param.value);
        return parseFloat(param.value) < 0 ? '('+ number.toString().replace('-', '') +')' : number
    }
    return parseFloat(0).toFixed(fractionalDigits)
}

export const numberFormat = (param) => {
    let formatInput = param.value;

    if(param && formatInput){
        return new Intl.NumberFormat().format(formatInput);
    }
    return 0
}

export const appendPercentSymbol = (param) => {
    let paramValue= param.value;
    if (paramValue) {
        return  paramValue+'%';
    }
    return '';
}

export const numberFormat5FractionalDigits = (param) => {
    return numberFormatter(param, 5)
}

export const numberFormat4FractionalDigits = (param) => {
    return numberFormatter(param, 4)
}

export const numberFormat4FractionalDigitsPer = (param) => {
    return numberFormat4FractionalDigits(param) + '%'
}
export const numberFormat3FractionalDigits = (param) => {
    return numberFormatter(param, 3)
}

export const numberFormat3FractionalDigitsStr = (param) => {
    if(param && param.value)
        return numberFormatter(param, 3)
    return ''
}

export const numberFormatIntegerStr = (param) => {
    if(param && param.value)
        return numberFormatter(param, 0)
    return ''
}

export const cellStyleChecker = (param) => {
    if(!!param.value)
        return parseFloat(param.value.toString()) < 0  ? { color:'red',textAlign: 'right' } : { color:'green',textAlign: 'right'}
    return {textAlign: 'right'}
}

export const cellStyleCheckerStatusError = (param) => {

    if (typeof param === 'string' && param.length > 0 && param.toUpperCase() === 'ERROR' || param.toUpperCase() === 'PENDING MPID') {
        return {backgroundColor: '#ce7c7c', color: '#6e0c01'};
    }
    return {};
}

export const cellAlignment = (param) => {
    return {textAlign: 'right'}
}

export const nonEmptyNumberFormatter = (param)=>{
    if(param && param.value) {
        return numberFormatter(param)
    }
    return
}

export const formatAmount = (value) => {
    return parseFloat(!!value?value.toString().replace(/,/g, ''):0);
}